import { useEffect, useState } from "react";
import { ALL_COUNTRIES } from "@/context/utils";

export function useIpStackDetails(isAfricaPage: boolean = false) {
  const [ipStackDetails, setIpStackDetails] = useState<any>({});

  useEffect(() => {
    function getCountryData() {
      if (typeof window !== "undefined") {
        const countryData = JSON.parse(localStorage.getItem("countryData") || "{}");
        if (countryData && Object.keys(countryData).length > 0) {
          setIpStackDetails(countryData);
        } else {
          setTimeout(getCountryData, 1000);
        }
      }
    }
    // this will try to get the latest localStorage data
    setTimeout(getCountryData, 1000);
  }, []);

  return {
     countryCode: ipStackDetails?.location?.calling_code?"+"+ipStackDetails?.location?.calling_code:isAfricaPage? "+213" : "+91",
     ipStackDetails,
    };
}
